import React from 'react';
import { Truck, PhoneCall, ShieldCheck, Gift } from 'lucide-react';

const InfoCard = ({ icon: Icon, text, className = "" }) => (
  <div className={`flex items-center justify-center gap-2 ${className}`}>
    <div className="text-emerald-500">
      <Icon size={20} className="text-emerald-500" />
    </div>
    <p className="text-sm text-gray-600">{text}</p>
  </div>
);

const Footer = () => {
  return (
    <>
      {/* Info Cards Section */}
      <div className="bg-white border-b">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 divide-y lg:divide-y-0 lg:divide-x divide-gray-200">
            <InfoCard
              icon={Truck}
              text="Free Shipping From €500.00"
              className="p-4"
            />
            <InfoCard
              icon={PhoneCall}
              text="Support 24/7 At Anytime"
              className="p-4"
            />
            <InfoCard
              icon={ShieldCheck}
              text="Secure Payment Totally Safe"
              className="p-4"
            />
            <InfoCard
              icon={Gift}
              text="Latest Offer Upto 20% Off"
              className="p-4"
            />
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="bg-white pt-16 pb-8">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company Section */}
            <div>
              <h4 className="text-lg font-semibold mb-4 text-gray-800">Company</h4>
              <ul className="space-y-2">
                <li><a href="/about" className="text-gray-600 hover:text-emerald-500">About Us</a></li>
                <li><a href="/contact" className="text-gray-600 hover:text-emerald-500">Contact Us</a></li>
                <li><a href="/faqs" className="text-gray-600 hover:text-emerald-500">FAQ</a></li>
               
              </ul>
            </div>

            {/* Latest News */}
            <div>
              <h4 className="text-lg font-semibold mb-4 text-gray-800">Latest News</h4>
              <ul className="space-y-2">
                <li><a href="/categories" className="text-gray-600 hover:text-emerald-500">Fish & Meat</a></li>
                <li><a href="/categories" className="text-gray-600 hover:text-emerald-500">Soft Drink</a></li>
                <li><a href="/categories" className="text-gray-600 hover:text-emerald-500">Milk & Dairy</a></li>
                <li><a href="/categories" className="text-gray-600 hover:text-emerald-500">Beauty & Health</a></li>
              </ul>
            </div>

            {/* My Account */}
            <div>
              <h4 className="text-lg font-semibold mb-4 text-gray-800">My Account</h4>
              <ul className="space-y-2">
                <li><a href="/profile" className="text-gray-600 hover:text-emerald-500">Dashboard</a></li>
                <li><a href="/profile" className="text-gray-600 hover:text-emerald-500">My Orders</a></li>
                <li><a href="/profile" className="text-gray-600 hover:text-emerald-500">Recent Orders</a></li>
                <li><a href="/profile" className="text-gray-600 hover:text-emerald-500">Update Profile</a></li>
              </ul>
            </div>

            {/* Store Info */}
            <div>
              <img src="https://i.pinimg.com/736x/09/0f/55/090f5516b8b09acf34fd4d55517c2e24.jpg" alt="Kacha Bazar" className="h-8 mb-4" />
              <p className="text-gray-600 mb-4">
                987 Andre Plain Suite High Street 838, Lake Hestertown, USA
              </p>
              <p className="text-gray-600 mb-2">Tel: +91 80560 161976</p>
              <p className="text-gray-600 mb-4">Email: info@ecomify.com</p>
            </div>
          </div>

          {/* Follow Us Section */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <div className="flex items-center space-x-4">
                <span className="text-gray-700 font-medium">Follow Us</span>
                <div className="flex space-x-2">
                  <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-blue-600 text-white hover:bg-blue-700">
                    <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                      <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/>
                    </svg>
                  </a>
                  <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-sky-500 text-white hover:bg-sky-600">
                    <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                      <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                    </svg>
                  </a>
                  <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-red-600 text-white hover:bg-red-700">
                    <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                      <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm4.441 16.892c-2.102.144-6.784.144-8.883 0-2.276-.156-2.541-1.27-2.558-4.892.017-3.629.285-4.736 2.558-4.892 2.099-.144 6.782-.144 8.883 0 2.277.156 2.541 1.27 2.559 4.892-.018 3.629-.285 4.736-2.559 4.892zm-6.441-7.892l4.917 2.917-4.917 2.917v-5.834z"/>
                    </svg>
                  </a>
                  <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-blue-800 text-white hover:bg-blue-900">
                    <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                      <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"/>
                    </svg>
                  </a>
                  <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-green-500 text-white hover:bg-green-600">
                    <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                      <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/>
                    </svg>
                  </a>
                </div>
              </div>

              {/* Call Us */}
              <div className="flex items-center space-x-2">
                <span className="text-gray-700 font-medium">Call Us Today!</span>
                <span className="text-emerald-500 font-semibold">+91 80560 16197</span>
              </div>

              {/* Payment Methods */}
              <div className="bg-white rounded-lg p-2 shadow-sm">
              <img src="https://t4.ftcdn.net/jpg/04/73/84/61/360_F_473846184_0k637f6855ZJqaulKqAmgJTEVGVibR1P.jpg" alt="Payment Methods" className="h-[100px]" />

              </div>
            </div>
          </div>

          {/* Copyright */}
          <div className="mt-8 text-center text-gray-500 text-sm">
            <p>Copyright 2025 @ ecomify. All rights reserved.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
